var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7143 15V16.3393C10.7143 16.7831 10.3545 17.1429 9.91071 17.1429H0.803571C0.359766 17.1429 0 16.7831 0 16.3393V4.01786C0 3.57405 0.359766 3.21429 0.803571 3.21429H3.21429V13.125C3.21429 14.1589 4.05539 15 5.08929 15H10.7143ZM10.7143 3.48214V0H5.08929C4.64548 0 4.28571 0.359766 4.28571 0.803571V13.125C4.28571 13.5688 4.64548 13.9286 5.08929 13.9286H14.1964C14.6402 13.9286 15 13.5688 15 13.125V4.28571H11.5179C11.0759 4.28571 10.7143 3.92411 10.7143 3.48214ZM14.7647 2.44323L12.5568 0.235346C12.4061 0.0846571 12.2017 1.11427e-06 11.9886 0L11.7857 0V3.21429H15V3.01142C15 2.79831 14.9153 2.59392 14.7647 2.44323Z",
    fill: "#2579FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.6498f50ccf3fa4575c348a40c0c47606.svg";
export { ForwardRef as ReactComponent };